const COLORS = [ '#a855f7', '#f59e0b', '#ef4444', '#f97316', '#ec4899' ];
let isDusted     = false;
let dusted       = [];
let activeOverlay = null;
let overlayTimer  = null;

/* ─── Helpers ─── */

function targets() {
	return Array.from(
		document.querySelectorAll( 'p,h1,h2,h3,h4,h5,h6,img,li,blockquote,figure,button' )
	).filter( ( el ) => {
		if ( el.closest( '#tg-wrap' ) ) return false;
		const r = el.getBoundingClientRect();
		if ( r.width < 10 || r.height < 10 ) return false;
		const s = getComputedStyle( el );
		if ( s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0' ) return false;
		if ( el.tagName === 'LI' && el.querySelector( 'ul,ol' ) ) return false;
		return true;
	} );
}

function shuffle( a ) {
	a = a.slice();
	for ( let i = a.length - 1; i > 0; i-- ) {
		const j = ( Math.random() * ( i + 1 ) ) | 0;
		[ a[ i ], a[ j ] ] = [ a[ j ], a[ i ] ];
	}
	return a;
}

/* ─── Dust animation ─── */

function dustElement( el ) {
	return new Promise( ( done ) => {
		const r   = el.getBoundingClientRect();
		const sx  = window.scrollX || window.pageXOffset;
		const sy  = window.scrollY || window.pageYOffset;
		const dpr = window.devicePixelRatio || 1;

		const cv  = document.createElement( 'canvas' );
		cv.width  = r.width  * dpr;
		cv.height = r.height * dpr;
		cv.style.cssText = `position:absolute;top:${ r.top + sy }px;left:${ r.left + sx }px;width:${ r.width }px;height:${ r.height }px;pointer-events:none;z-index:99999`;
		document.body.appendChild( cv );

		const ctx = cv.getContext( '2d' );
		ctx.scale( dpr, dpr );

		const W = r.width, H = r.height;
		const count = Math.min( 300, Math.max( 40, ( W * H / 60 ) | 0 ) );
		const pts = Array.from( { length: count }, () => ( {
			x: Math.random() * W,
			y: Math.random() * H,
			vx: ( Math.random() - 0.4 ) * 4,
			vy: ( Math.random() - 0.9 ) * 3,
			sz: Math.random() * 3 + 0.5,
			op: 1,
			c: COLORS[ ( Math.random() * COLORS.length ) | 0 ],
		} ) );

		el.style.visibility = 'hidden';

		const FRAMES = 90;
		let f = 0;

		( function tick() {
			ctx.clearRect( 0, 0, W, H );
			f++;
			for ( const p of pts ) {
				p.x  += p.vx;
				p.y  += p.vy;
				p.vy += 0.1;
				p.vx *= 0.98;
				p.op -= 1 / FRAMES;
				if ( p.op <= 0 ) continue;
				ctx.globalAlpha = p.op;
				ctx.fillStyle   = p.c;
				ctx.beginPath();
				ctx.arc( p.x, p.y, p.sz, 0, Math.PI * 2 );
				ctx.fill();
			}
			f < FRAMES ? requestAnimationFrame( tick ) : ( cv.remove(), done() );
		} )();
	} );
}

/* ─── Logo overlay ─── */

function showGauntlet() {
	if ( ! document.getElementById( 'tg-css' ) ) {
		const s = document.createElement( 'style' );
		s.id = 'tg-css';
		s.textContent = `
			@keyframes tg-in      { from{opacity:0;transform:translateY(40px)} to{opacity:1;transform:translateY(0)} }
			@keyframes tg-out     { from{opacity:1;transform:translateY(0)} to{opacity:0;transform:translateY(-30px)} }
			@keyframes tg-fill-up { from{clip-path:inset(100% 0 0 0)} to{clip-path:inset(0% 0 0 0)} }
			#tg-wrap { animation: tg-in .35s ease-out forwards; }
			#tg-wrap img { animation: tg-fill-up .8s cubic-bezier(.4,0,.2,1) forwards; }
		`;
		document.head.appendChild( s );
	}

	const wrap = document.createElement( 'div' );
	wrap.id = 'tg-wrap';
	wrap.style.cssText = 'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:999999;pointer-events:none';

	wrap.innerHTML = `<img
		src="/wp-content/themes/bilberrry/assets/images/logo_animated.svg"
		alt="snap"
		style="width:auto;height:70vh;max-height:500px"
	/>`;

	document.body.appendChild( wrap );

	activeOverlay = wrap;
	overlayTimer  = setTimeout( () => hideOverlay(), 1000 );
}

function hideOverlay() {
	clearTimeout( overlayTimer );
	const wrap = activeOverlay;
	if ( ! wrap ) return;
	activeOverlay = null;
	wrap.style.animation = 'tg-out .25s ease forwards';
	setTimeout( () => wrap.remove(), 250 );
}

/* ─── Core ─── */

function restore() {
	hideOverlay();
	dusted.forEach( ( el ) => ( el.style.visibility = '' ) );
	dusted   = [];
	isDusted = false;
}

async function snap() {
	if ( isDusted ) {
		restore();
		return;
	}

	showGauntlet();

	const all  = targets();
	const half = shuffle( all ).slice( 0, Math.floor( all.length * 0.5 ) );
	dusted   = half;
	isDusted = true;

	const BATCH = 8;
	for ( let i = 0; i < half.length; i += BATCH ) {
		await new Promise( ( r ) => setTimeout( r, 30 + Math.random() * 40 ) );
		half.slice( i, i + BATCH ).forEach( dustElement );
	}
}

export default snap;
